var _g, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInformationButton = function SvgInformationButton(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3019_38281)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99935 6.66667C10.4596 6.66667 10.8327 6.29357 10.8327 5.83333C10.8327 5.3731 10.4596 5 9.99935 5C9.53911 5 9.16602 5.3731 9.16602 5.83333C9.16602 6.29357 9.53911 6.66667 9.99935 6.66667Z",
    fill: "#082244"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833008 9.99992C0.833008 4.93731 4.93706 0.833252 9.99967 0.833252C15.0623 0.833252 19.1663 4.93731 19.1663 9.99992C19.1663 15.0625 15.0623 19.1666 9.99967 19.1666C4.93706 19.1666 0.833008 15.0625 0.833008 9.99992ZM9.99967 2.49992C5.85754 2.49992 2.49967 5.85778 2.49967 9.99992C2.49967 14.1421 5.85754 17.4999 9.99967 17.4999C14.1418 17.4999 17.4997 14.1421 17.4997 9.99992C17.4997 5.85778 14.1418 2.49992 9.99967 2.49992Z",
    fill: "#082244"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99935 7.9165C10.4596 7.9165 10.8327 8.2896 10.8327 8.74984V14.1665C10.8327 14.6267 10.4596 14.9998 9.99935 14.9998C9.53911 14.9998 9.16602 14.6267 9.16602 14.1665V8.74984C9.16602 8.2896 9.53911 7.9165 9.99935 7.9165Z",
    fill: "#082244"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3019_38281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInformationButton, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/information-button.86558f82.svg";
export { ForwardRef as ReactComponent };